export default "__VITE_ASSET__CSRH2V2O__"